import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div {{this.setAria}} aria-label={{this.ariaLabel}} data-value={{this.value}} class=\"item\" ...attributes>\n  {{!-- @glint-expect-error --}}\n  {{yield}}\n</div>", {
  moduleName: "core/components/fui-dropdown/item/index.hbs"
});